var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140967",
    transform: "translate(-.435 -.435)",
    fill: "none",
    d: "M0 0h12v12H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon plus",
    transform: "translate(.435 .435)",
    clipPath: "url(#plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Uni\\xE3o 13",
    d: "M4.749 9.234V6.38H1.894a.815.815 0 010-1.63H4.75V1.895a.816.816 0 011.631 0v2.856h2.855a.816.816 0 110 1.632H6.381v2.855a.816.816 0 11-1.631 0z",
    fill: "#378ff7",
    stroke: "rgba(0,0,0,0)"
  }))));
}
export default __webpack_public_path__ + "static/media/plus.735b9ce1.svg";
export { SvgPlus as ReactComponent };